import { gql } from '@apollo/client';
import {
  ANALYTICS_PAGE_BASE_DATA,
  EDIT_EXPERIMENT_ATTRIBUTES,
  EDIT_EXPERIMENT_VARIANT_ATTRIBUTES,
} from 'api/fragments';

export const deleteExperimentMutation = gql`
  mutation deleteExperiment($id: Long!) {
    deleteExperiment(id: $id) {
      ... on DeleteExperimentSuccess {
        id
      }
      ... on DeleteExperimentFailure {
        message
      }
    }
  }
`;

export const endExperimentMutation = gql`
  mutation endExperiment($id: Long!, $winnerId: Long) {
    endExperiment(id: $id, winnerId: $winnerId) {
      ... on Experiment {
        ...analyticsPageBaseDataAttributes
      }
      ... on ExperimentError {
        message
      }
    }
  }
  ${ANALYTICS_PAGE_BASE_DATA}
`;

export const launchExperimentMutation = gql`
  mutation startExperiment($id: Long!) {
    startExperiment(id: $id) {
      ... on Experiment {
        id
      }
      ... on ExperimentError {
        message
      }
    }
  }
`;

export const launchExperimentInAnalyticsPageMutation = gql`
  mutation startExperiment($id: Long!) {
    startExperiment(id: $id) {
      ... on Experiment {
        ...analyticsPageBaseDataAttributes
      }
      ... on ExperimentError {
        message
      }
    }
  }
  ${ANALYTICS_PAGE_BASE_DATA}
`;

export const updateExperimentNameMutation = gql`
  mutation renameExperiment($id: Long!, $newName: String!) {
    renameExperiment(id: $id, newName: $newName) {
      ... on Experiment {
        name
      }
      ... on ExperimentError {
        message
      }
    }
  }
`;

export const createExperimentMutation = gql`
  mutation createExperiment($campaignId: Long!, $name: String!, $experimentType: ExperimentType!) {
    createExperiment(campaignId: $campaignId, name: $name, experimentType: $experimentType) {
      ... on Experiment {
        id
      }
      ... on ExperimentError {
        message
      }
    }
  }
`;

export const deleteExperimentVariantMutation = gql`
  mutation deleteVariation($experimentId: Long!, $variationId: Long!, $locale: String) {
    deleteVariation(experimentId: $experimentId, variationId: $variationId) {
      ... on Experiment {
        variations {
          ... on ExperimentVariation {
            ...editExperimentVariantAttributes
          }
        }
      }
      ... on ExperimentError {
        message
      }
    }
  }
  ${EDIT_EXPERIMENT_VARIANT_ATTRIBUTES}
`;

export const renameExperimentVariantMutation = gql`
  mutation renameVariation(
    $experimentId: Long!
    $variationId: Long!
    $variationName: String!
    $locale: String
  ) {
    renameVariation(
      experimentId: $experimentId
      variationId: $variationId
      variationName: $variationName
    ) {
      ... on Experiment {
        variations {
          ... on ExperimentVariation {
            ...editExperimentVariantAttributes
          }
        }
      }
      ... on ExperimentError {
        message
      }
    }
  }
  ${EDIT_EXPERIMENT_VARIANT_ATTRIBUTES}
`;

export const addExperimentVariantMutation = gql`
  mutation createVariation(
    $experimentId: Long!
    $copyFromTemplateId: Long!
    $newNameOpt: String
    $locale: String
  ) {
    createVariation(
      experimentId: $experimentId
      copyFromTemplateId: $copyFromTemplateId
      newNameOpt: $newNameOpt
    ) {
      ... on Experiment {
        variations {
          ... on ExperimentVariation {
            ...editExperimentVariantAttributes
          }
        }
      }
      ... on ExperimentError {
        message
      }
    }
  }
  ${EDIT_EXPERIMENT_VARIANT_ATTRIBUTES}
`;

export const updateExperimentVariantMutation = gql`
  mutation updateVariation(
    $experimentId: Long!
    $variationId: Long!
    $variationName: String
    $variationType: ExperimentVariationInputType!
    $locale: String
    $sendTimeVariation: SendTimeVariationInput
    $emailVariation: EmailVariationInput
    $smsVariation: SmsVariationInput
    $pushVariation: PushVariationInput
    $webPushVariation: WebPushVariationInput
  ) {
    updateVariation(
      experimentId: $experimentId
      variationId: $variationId
      variationName: $variationName
      variationType: $variationType
      locale: $locale
      sendTimeVariation: $sendTimeVariation
      emailVariation: $emailVariation
      smsVariation: $smsVariation
      pushVariation: $pushVariation
      webPushVariation: $webPushVariation
    ) {
      ... on Experiment {
        variations {
          ... on ExperimentVariation {
            ...editExperimentVariantAttributes
          }
        }
      }
      ... on ExperimentError {
        message
      }
    }
  }
  ${EDIT_EXPERIMENT_VARIANT_ATTRIBUTES}
`;

export const updateExperimentSettings = gql`
  mutation updateExperimentSettings(
    $experimentId: Long!
    $conversionEventSettings: ConversionEventSettingsInput!
    $sendTimeSettings: SendTimeSettingsInput
    $explorationTriggerSettings: TriggerExplorationSettingsInput
    $explorationBlastSettings: BlastExplorationSettingsInput
    $holdoutSettings: HoldoutSettingsInput
    $locale: String
  ) {
    updateExperimentSettings(
      experimentId: $experimentId
      conversionEventSettings: $conversionEventSettings
      sendTimeSettings: $sendTimeSettings
      explorationTriggerSettings: $explorationTriggerSettings
      explorationBlastSettings: $explorationBlastSettings
      holdoutSettings: $holdoutSettings
    ) {
      ... on Experiment {
        ...editExperimentAttributes
      }
      ... on ExperimentError {
        message
      }
    }
  }
  ${EDIT_EXPERIMENT_ATTRIBUTES}
`;
